import React, { HTMLAttributes } from 'react'

import { cn } from '@frame/lib/utils/cn'

type Props = {
  isNext?: boolean
  className?: HTMLAttributes<HTMLDivElement>['className']
}

export function HoverOverlay({ isNext, className }: Props) {
  if (isNext) {
    return (
      <>
        <div
          className={cn(
            'absolute inset-0 left-[2px] top-[2px] z-10 h-[calc(100%-4px)] w-[calc(100%-4px)] rounded-[10px] bg-cobranding opacity-0 transition-opacity group-hover:opacity-100',
            className
          )}
        />
        <div
          className={cn(
            'absolute inset-0 left-[2px] top-[2px] z-10 h-[calc(100%-4px)] w-[calc(100%-4px)] rounded-[10px] bg-white transition-opacity group-hover:opacity-90',
            className
          )}
        />
      </>
    )
  }

  return (
    <div
      className={cn(
        'absolute inset-0 z-10 rounded-[10px] bg-cobranding-hover opacity-0 transition-opacity group-hover:opacity-100',
        className
      )}
    />
  )
}
